import { createContext, useState, useContext } from "react";

// Create Context
const CollegeContext = createContext();

// Provider Component
export const CollegeProvider = ({ children }) => {
  const [selectedCollege, setSelectedCollege] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);

  return (
    <CollegeContext.Provider
      value={{ selectedCollege, setSelectedCollege, uploadedFiles, setUploadedFiles }}
    >
      {children}
    </CollegeContext.Provider>
  );
};

// Custom Hook to Use Context
export const useCollege = () => useContext(CollegeContext);
